export const types = {
  INIT_PARAMS: "INIT_PARAMS",
  ADD_FILES: "ADD_FILES",
  HANDLE_CHANGE: "HANDLE_CHANGE",
};
